const sliderInit = (section) => {
  if (!section) return;
  const mediaLists = section.querySelectorAll(".js-media-list");
  if (mediaLists.length === 0) return;
  const sublists = section.querySelectorAll(".js-media-sublist");
  const popupSlider = section.querySelector(".js-popup-slider");
  const navPrev = section.querySelector(".product-slider-nav-prev");
  const navNext = section.querySelector(".product-slider-nav-next");
  mediaLists.forEach((elem, index) => {
    if (elem.swiper) return;
    let slider = new Swiper(elem, {
      slidesPerView: 1,
      spaceBetween: 8,
      autoHeight: false,
      speed: 500,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: navNext,
        prevEl: navPrev,
      },
      thumbs: {
        swiper: sublists.length > 0 ? sublists[index]?.swiper : "",
      },
      on: {
        slideChangeTransitionStart: function () {
          if (sublists.length > 0) {
            sublists[0].swiper.slideTo(elem.swiper.activeIndex);
          }
        },
        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
          if (popupSlider && popupSlider.swiper) {
            popupSlider.swiper.slideTo(this.activeIndex);
          }
        },
        slideChangeTransitionEnd: function () {
          if (this.slides[this.activeIndex]?.querySelector("model-viewer")) {
            this.slides[this.activeIndex]
              .querySelector(".shopify-model-viewer-ui__button--poster")
              .removeAttribute("hidden");
          }
        },
        touchStart: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            if (
              !this.slides[this.activeIndex]
                .querySelector("model-viewer")
                .classList.contains("shopify-model-viewer-ui__disabled")
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });
  });
};
const subSliderInit = (section) => {
  if (!section) return;
  const sublists = section.querySelectorAll(".js-media-sublist");
  if (sublists.length > 0) {
    sublists.forEach((elem) => {
      if (elem.swiper) return;
      const sliderDirection = elem.dataset.thumbsDirection || "vertical";
      let subSlider = new Swiper(elem, {
        spaceBetween: 8,
        slidesPerView: "auto",
        direction: "horizontal",
        freeMode: true,
        allowTouchMove: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        on: {
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
        breakpoints: {
          990: {
            slidesPerView: "auto",
            direction: sliderDirection,
          },
        },
      });
    });
  }
};
function isIOS() {
  const ua = navigator.userAgent;
  const isIPhone = /iPhone|iPod/.test(ua);
  const isIPad =
    /iPad/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  return isIPhone || isIPad;
}
if (isIOS()) {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, maximum-scale=1.0"
    );
  }
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
const initDetailsAccessibility = () => {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute("aria-expanded", "false");
    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }
    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
    if (summary.closest("header-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  });
};
(window.requestIdleCallback || setTimeout)(initDetailsAccessibility);
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  elementToFocus?.focus();
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => {
    if (!video.classList.contains("autoplay-persistent")) {
      video.pause();
    }
  });
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus({ preventScroll: true });
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this._errorEl = document.createElement("p");
    this._errorEl.className = "quantity__error-text";
    this._errorEl.setAttribute("role", "alert");
    this._errorEl.setAttribute("aria-live", "assertive");
    this._errorEl.hidden = true;
    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
    this.updateButtonStates();
    const eventList = ["paste", "input"];
    for (const event of eventList) {
      this.input.addEventListener(event, (e) => {
        const numberRegex = /^\d*$/; // allows empty string while typing
        const value = e.currentTarget.value;
        if (!numberRegex.test(value)) {
          e.currentTarget.value = 1;
        }
        this.updateButtonStates();
        this.validateQuantityRules();
      });
    }
    this.input.addEventListener("focusout", (e) => {
      const min = this.getMinimumValue();
      const max = this.getMaximumValue();
      const value = parseInt(e.currentTarget.value, 10);
      if (e.currentTarget.value === "" || value < min) {
        e.currentTarget.value = min;
      } else if (max !== null && value > max) {
        e.currentTarget.value = max;
      }
      this.updateButtonStates();
      this.clearQuantityError();
    });
  }
  connectedCallback() {
    if (this._errorEl && !this._errorEl.parentNode) {
      this.insertAdjacentElement("afterend", this._errorEl);
    }
  }
  disconnectedCallback() {
    if (this._errorEl && this._errorEl.parentNode) {
      this._errorEl.remove();
    }
  }
  getMinimumValue() {
    const min = parseInt(this.input.min, 10);
    return isNaN(min) ? 0 : min;
  }
  getMaximumValue() {
    const max = parseInt(this.input.max, 10);
    return isNaN(max) ? null : max;
  }
  updateButtonStates() {
    const value = parseInt(this.input.value, 10);
    const min = this.getMinimumValue();
    const max = this.getMaximumValue();
    const minusBtn = this.querySelector('button[name="minus"]');
    const plusBtn = this.querySelector('button[name="plus"]');
    if (minusBtn) {
      if (value <= min) {
        minusBtn.setAttribute("disabled", "");
      } else {
        minusBtn.removeAttribute("disabled");
      }
    }
    if (plusBtn) {
      if (max !== null && value >= max) {
        plusBtn.setAttribute("disabled", "");
      } else {
        plusBtn.removeAttribute("disabled");
      }
    }
  }
  setMinimumDisable() {
    this.updateButtonStates();
  }
  validateQuantityRules() {
    const value = parseInt(this.input.value, 10);
    if (isNaN(value)) {
      this.clearQuantityError();
      return;
    }
    const min = this.getMinimumValue();
    const max = this.getMaximumValue();
    const step = parseInt(this.input.step, 10) || 1;
    const strings = window.quantityStrings || {};
    if (value < min && strings.minimum) {
      this.showQuantityError(strings.minimum.replace("[min]", min));
    } else if (max !== null && value > max && strings.maximum) {
      this.showQuantityError(strings.maximum.replace("[max]", max));
    } else if (step > 1 && value % step !== 0 && strings.step) {
      this.showQuantityError(strings.step.replace("[step]", step));
    } else {
      this.clearQuantityError();
    }
  }
  showQuantityError(message) {
    this._errorEl.textContent = message;
    this._errorEl.hidden = false;
  }
  clearQuantityError() {
    this._errorEl.hidden = true;
    this._errorEl.textContent = "";
  }
  onButtonClick(event) {
    event.preventDefault();
    const isPlus = event.target.name === "plus";
    const min = this.getMinimumValue();
    const max = this.getMaximumValue();
    const currentValue = parseInt(this.input.value || min, 10);
    if (isPlus) {
      if (max === null || currentValue < max) {
        this.input.stepUp();
      }
    } else {
      if (currentValue > min) {
        this.input.stepDown();
      }
    }
    this.updateButtonStates();
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("quantity-input", QuantityInput);
class ProductQuantityInput extends QuantityInput {
  constructor() {
    super();
  }
  getMinimumValue() {
    const min = parseInt(this.input.min, 10);
    return isNaN(min) ? 1 : Math.max(1, min);
  }
}
customElements.define("product-quantity-input", ProductQuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );
  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    if (!opt) return;
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);
    this.headerWrapper = document.querySelector(".header-wrapper");
    if (this.headerWrapper) this.headerWrapper.preventHide = false;
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button, .mobile-facets__clear").forEach((button) => {
      if (
        this.querySelector(".header__localization-button") === button ||
        this.querySelector(".header__localization-lang-button") === button ||
        button.classList.contains("mobile-facets__footer__button")
      ) {
        return;
      }
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }
  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;
    openDetailsElement === this.menuDrawerContainer
      ? this.closeMenuDrawer(event, this.menuDrawerContainer.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement)
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        isOpen ? (event.preventDefault(), this.closeMenuDrawer(event, summaryElement)) : this.openMenuDrawer(summaryElement);
    } else {
      // Submenu works as an accordion: no focus trap, just update its state
      if (isOpen) {
        summaryElement.setAttribute("aria-expanded", "false");
        detailsElement.classList.remove("menu-opening");
      } else {
        summaryElement.setAttribute("aria-expanded", "true");
        setTimeout(() => {
          detailsElement.classList.add("menu-opening");
        });
      }
    }
  }
  openMenuDrawer(summaryElement) {
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-drawer`);
  }
  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(`overflow-hidden-drawer`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      if (this.headerWrapper) this.headerWrapper.preventHide = false;
    }
  }
  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(event) {
    document.body.classList.remove("overflow-hidden-drawer");
    const detailsElement = event.currentTarget.closest("details");
    if (!detailsElement) return;
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement?.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".shopify-section-header");
    this.headerWrapper = document.querySelector(".header-wrapper");
    if (this.headerWrapper) this.headerWrapper.preventHide = false;
    this.menuDrawerContainer = this.querySelector(".menu-drawer-container");
    const summaryElements = this.querySelectorAll("summary");
    if (summaryElements && summaryElements.length) {
      this.addAccessibilityAttributes(summaryElements);
    }
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }
  connectedCallback() {
    this.initMobileMegaMenus();
  }
  disconnectedCallback() {}
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    if (detailsElement === this.menuDrawerContainer) {
      if (isOpen) {
        event.preventDefault();
        this.closeMenuDrawer(event, summaryElement)
      } else {
        this.openMenuDrawer(summaryElement);
      }
    } else {
      
      const ariaExpandedValue =
        summaryElement.getAttribute("aria-expanded") === "true";
      summaryElement.setAttribute("aria-expanded", !ariaExpandedValue);
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }
  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) => {
      summary.addEventListener("click", this.onSummaryClick.bind(this));
    });
    this.querySelectorAll("button").forEach((button) => {
      if (
        this.querySelector(".header__localization-button") === button ||
        this.querySelector(".header__localization-lang-button") === button ||
        button.classList.contains("mobile-facets__footer__button") ||
        button.classList.contains("header__search-close") ||
        button.closest(".mobile-mega-menu-back-button")
      ) {
        return;
      }
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;
    openDetailsElement === this.menuDrawerContainer
      ? this.closeMenuDrawer(event, this.menuDrawerContainer.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }
  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.menuDrawerContainer.hasAttribute("open") &&
        !this.menuDrawerContainer.contains(document.activeElement)
      ) {
        const headerSearch = this.querySelector("header-search");
        if (headerSearch && headerSearch.hasAttribute("open")) {
          return;
        }
        this.closeMenuDrawer();
      }
    });
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    if (!detailsElement) return;
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement?.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
  openMenuDrawer(summaryElement) {
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    setTimeout(() => {
      this.menuDrawerContainer.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.menuDrawerContainer, summaryElement);
    document.body.classList.add(`overflow-hidden-drawer`);
  }
  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.menuDrawerContainer.classList.remove("menu-opening");
      this.menuDrawerContainer
        .querySelectorAll("details")
        .forEach((details) => {
          details.removeAttribute("open");
          details.classList.remove("menu-opening");
        });
      this.menuDrawerContainer
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(`overflow-hidden-drawer`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.menuDrawerContainer);
      if (this.headerWrapper) this.headerWrapper.preventHide = false;
    }
  }
  initMobileMegaMenus() {
    const mobileTemplates = document.querySelectorAll(
      ".mobile-mega-menu-template"
    );
    const mobileMenuLinks = this.headerWrapper.querySelectorAll(
      ".menu-drawer__menu-link[data-handle]"
    );
    mobileMenuLinks.forEach((link) => {
      const handle = link.dataset.handle;
      const url = link.href;
      const target = link.target;
      const label = link.innerHTML;
      if (!handle) return;
      const template = Array.from(mobileTemplates).find(
        (template) => template.dataset.trigger === handle
      );
      if (!template) return;
      const cloned = template.content.firstElementChild?.cloneNode(true);
      if (!cloned) return;
      const clonedMainLink = cloned.querySelector(
        ".menu-drawer__menu-link--mobile-mega-menu"
      );
      clonedMainLink.href = url;
      clonedMainLink.target = target;
      clonedMainLink.innerHTML = label;
      const parent = link.closest("li");
      parent.innerHTML = "";
      parent.appendChild(cloned);
      const backButton = cloned.querySelector(".mobile-mega-menu-back-button");
      if (backButton) {
        backButton.addEventListener(
          "click",
          this.onCloseButtonClick.bind(this)
        );
      }
      const summary = cloned.querySelector("summary");
      if (summary) {
        summary.addEventListener("click", this.onSummaryClick.bind(this));
      }
      this.initMobileMegaMenuSlider(cloned);
    });
  }
  initMobileMegaMenuSlider(megaMenu) {
    const slider = megaMenu.querySelector(".mobile-mega-menu-slider");
    if (!slider) return;
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 1000,
      loop: false,
      watchOverflow: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      on: {
        afterInit: () => {
          this.positionMobileMegaMenuSliderNav(slider);
        },
        resize: () => {
          this.positionMobileMegaMenuSliderNav(slider);
        },
      },
      navigation: {
        prevEl: megaMenu.querySelector(
          ".mobile-mega-menu-slider-nav-button--prev"
        ),
        nextEl: megaMenu.querySelector(
          ".mobile-mega-menu-slider-nav-button--next"
        ),
      },
    });
  }
  positionMobileMegaMenuSliderNav(slider) {
    const nav = slider.querySelector(".mobile-mega-menu-slider-nav");
    if (!nav) return;
    const firstSlide = slider.querySelector(".mobile-mega-menu-slide");
    if (!firstSlide) return;
    const imgWrapper = firstSlide.querySelector(
      ".card-small-image-link-wrapper"
    );
    if (!imgWrapper) return;
    const imgRect = imgWrapper.getBoundingClientRect();
    const img = imgWrapper.querySelector("img");
    if (img && !img.complete) {
      img.addEventListener("load", () =>
        this.positionMobileMegaMenuSliderNav(slider)
      );
      return;
    }
    const offsetY = (imgRect.height - nav.offsetHeight) / 2;
    nav.style.top = `${Math.max(offsetY, 0)}px`;
    nav.style.transform = "none";
    nav.classList.add("mobile-mega-menu-slider-nav--visible");
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onClickInside = this.onClickInside.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.animateFollow = this.animateFollow.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);
    this.mouseX = 0;
    this.mouseY = 0;
    this.floatingX = 0;
    this.floatingY = 0;
    this.raf = null;
    this.mediaQuery = window.matchMedia(
      "(pointer: fine) and (min-width: 990px)"
    );
    this.dynamicEnabled = false;
    document.body.appendChild(this);
  }
  connectedCallback() {
    this.dialogEl = this.querySelector('[role="dialog"]');
    this.closeButton = this.querySelector('[id^="ModalClose-"]');
    this.closeButton?.addEventListener("click", this.onCloseClick);
    this.addEventListener("keyup", this.onKeyUp);
    this.addEventListener("click", this.onClickInside);
  }
  disconnectedCallback() {
    this.closeButton?.removeEventListener("click", this.onCloseClick);
    this.removeEventListener("keyup", this.onKeyUp);
    this.removeEventListener("click", this.onClickInside);
    this._disableDynamic();
    this.mediaQuery.removeEventListener("change", this.onMediaChange);
  }
  show(opener, event) {
    this.openedBy = opener;
    this.setAttribute("open", "");
    document.body.classList.add("overflow-hidden");
    window.pauseAllMedia?.();
    this.mediaQuery.addEventListener("change", this.onMediaChange);
    this.onMediaChange(this.mediaQuery);
    if (event && this.dynamicEnabled) {
      this.instantPositionCloseButton(event);
    }
    this.addEventListener(
      "transitionend",
      () => trapFocus(this, this.dialogEl),
      { once: true }
    );
  }
  hide() {
    this.classList.add("closing");
    setTimeout(() => {
      this.removeAttribute("open");
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia?.();
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      this._disableDynamic();
      this.mediaQuery.removeEventListener("change", this.onMediaChange);
      const mediaContent = document.querySelector(
        ".product-media-modal__content"
      );
      if (mediaContent) {
        mediaContent.classList.remove("zoom");
      }
      this.classList.remove("closing");
    }, 450);
  }
  instantPositionCloseButton(event) {
    if (!this.closeButton) return;
    const offsetX = 32,
      offsetY = 32;
    this.mouseX = event.clientX - offsetX;
    this.mouseY = event.clientY - offsetY;
    this.floatingX = this.mouseX;
    this.floatingY = this.mouseY;
    Object.assign(this.closeButton.style, {
      position: "fixed",
      zIndex: "9999",
      left: `${this.floatingX}px`,
      top: `${this.floatingY}px`,
      pointerEvents: "none",
    });
    const container = this.querySelector(".product-popup-modal__content");
    if (
      !event.target.closest(".product-popup-modal__content-info") &&
      !this.isMouseOverScrollbar(event, container)
    ) {
      this.classList.add("cursor-active");
    } else {
      this.classList.remove("cursor-active");
    }
  }
  onMediaChange(e) {
    if (e.matches && !this.dynamicEnabled) {
      this.dynamicEnabled = true;
      document.addEventListener("mousemove", this.onMouseMove);
      this.raf = requestAnimationFrame(this.animateFollow);
    } else if (!e.matches && this.dynamicEnabled) {
      this._disableDynamic();
    }
  }
  _disableDynamic() {
    if (!this.dynamicEnabled) return;
    document.removeEventListener("mousemove", this.onMouseMove);
    cancelAnimationFrame(this.raf);
    this.dynamicEnabled = false;
    if (this.closeButton) {
      this.closeButton.style.position = "";
      this.closeButton.style.left = "";
      this.closeButton.style.top = "";
      this.closeButton.style.pointerEvents = "";
      this.closeButton.style.zIndex = "";
      this.classList.remove("cursor-active");
    }
  }
  isMouseOverScrollbar(event, container) {
    const rect = container.getBoundingClientRect();
    const hasVertical = container.scrollHeight > container.clientHeight;
    const withinY = event.clientY >= rect.top && event.clientY <= rect.bottom;
    return (
      hasVertical &&
      event.clientX >= rect.left + container.clientWidth &&
      withinY
    );
  }
  onMouseMove(event) {
    if (!this.closeButton) return;
    const offsetX = 32,
      offsetY = 32;
    this.mouseX = event.clientX - offsetX;
    this.mouseY = event.clientY - offsetY;
    const container = this.querySelector(".product-popup-modal__content");
    if (
      !event.target.closest(".product-popup-modal__content-info") &&
      !this.isMouseOverScrollbar(event, container)
    ) {
      this.classList.add("cursor-active");
    } else {
      this.classList.remove("cursor-active");
    }
  }
  animateFollow() {
    if (!this.closeButton) return;
    const ease = 0.25;
    this.floatingX += (this.mouseX - this.floatingX) * ease;
    this.floatingY += (this.mouseY - this.floatingY) * ease;
    Object.assign(this.closeButton.style, {
      position: "fixed",
      zIndex: "9999",
      left: `${this.floatingX}px`,
      top: `${this.floatingY}px`,
      pointerEvents: "none",
    });
    this.raf = requestAnimationFrame(this.animateFollow);
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() === "ESCAPE") {
      this.hide();
    }
  }
  onClickInside(event) {
    if (
      !event.target.closest(".product-popup-modal__content-info") &&
      this.dynamicEnabled
    ) {
      this.onCloseClick(event);
    }
  }
  onCloseClick(e) {
    e.stopPropagation();
    if (!this.closeButton) {
      return this.hide();
    }
    this.closeButton.classList.add("pulse");
    this.hide();
    const done = () => {
      this.closeButton.removeEventListener("animationend", done);
      this.closeButton.classList.remove("pulse");
    };
    this.closeButton.addEventListener("animationend", done);
  }
}
customElements.define("modal-dialog", ModalDialog);
class ProductModal extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.syncToMedia(opener?.dataset?.mediaId);
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }
  syncToMedia(mediaId) {
    if (!mediaId) return;
    const mediaContent = this.querySelector(".product-media-modal__content");
    const popupSlider = mediaContent?.swiper;
    if (!popupSlider) return;
    const slides = [...this.querySelectorAll(".product-media-modal__item")];
    const targetIndex = slides.findIndex((slide) =>
      slide.querySelector(`[data-media-id="${mediaId}"]`)
    );
    if (targetIndex >= 0) {
      popupSlider.slideTo(targetIndex, 0);
      popupSlider.update();
    }
  }
  hide() {
    let isOpen = false;
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });
    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }
    const images = document.querySelector(".product-media-modal__content");
    if (images) {
      images.classList.remove("zoom");
    }
  }
}
if (!customElements.get("product-modal")) {
  customElements.define("product-modal", ProductModal);
}
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    if (!button) return;
    button.addEventListener("click", (event) => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button, event);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
    if (this.getAttribute("data-autoplay") === "true") {
      this.loadContent();
    }
  }
  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );
      this.setAttribute("loaded", true);
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (
              this.getAttribute("data-autoplay") === "true" &&
              this.closest(".swiper-slide-active")
            ) {
              if (entry.target.nodeName === "VIDEO") {
                let playPromise = entry.target.play();
                if (playPromise !== undefined) {
                  playPromise
                    .then((_) => {})
                    .catch((error) => {
                      console.error("Error playing video:", error);
                    });
                }
              } else if (
                entry.target.nodeName === "IFRAME" &&
                entry.target.contentWindow
              ) {
                if (entry.target.classList.contains("js-youtube")) {
                  entry.target.contentWindow.postMessage(
                    '{"event":"command","func":"playVideo","args":""}',
                    "*"
                  );
                } else {
                  entry.target.contentWindow.postMessage(
                    '{"method":"play"}',
                    "*"
                  );
                }
              }
            }
          } else {
            if (entry.target.nodeName === "VIDEO") {
              entry.target.pause();
            } else if (
              entry.target.nodeName === "IFRAME" &&
              entry.target.contentWindow
            ) {
              if (entry.target.classList.contains("js-youtube")) {
                entry.target.contentWindow.postMessage(
                  '{"event":"command","func":"pauseVideo","args":""}',
                  "*"
                );
              } else {
                entry.target.contentWindow.postMessage(
                  '{"method":"pause"}',
                  "*"
                );
              }
            }
          }
        });
      });
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (
        deferredElement.nodeName === "VIDEO" ||
        deferredElement.nodeName === "IFRAME"
      ) {
        videoObserver.observe(deferredElement);
      }
      if (this.closest(".swiper-slide-active")?.querySelector("model-viewer")) {
        const modelViewer = this.closest(".swiper-slide-active").querySelector(
          "model-viewer"
        );
        if (
          !modelViewer.classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
  }
  onVariantChange(event) {
    if (!this.contains(event.target)) return;
    const combinedProductURL = event.target.dataset?.productUrl;
    const isCombinedProductChange =
      this.isCombinedProductChange(combinedProductURL);
    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    this.highVariantRequestUrl = "";
    this.updateOptions();
    if (!isCombinedProductChange) {
      this.updateMasterId();
    } else {
      this.currentVariant = null;
      this.updateURL(combinedProductURL, "");
    }
    this.toggleAddButton(true, "");
    if (
      isCombinedProductChange ||
      (!this.currentVariant && this.dataset.isHighVariantProduct === "true") ||
      (!this.currentVariant && combinedProductURL)
    ) {
      const selectedValuesIds = this.getSelectedValuesIds();
      this.highVariantRequestUrl = this.createRequestUrl({
        selectedValuesIds: selectedValuesIds,
        combinedProductURL: combinedProductURL,
      });
      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
        if (isCombinedProductChange || combinedProductURL) {
          this.isCombinedListingsNeedUpdate = true;
        }
      }
    }
    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
    }
    this.cleanErrors();
    if (!this.currentVariant) {
      if (this.isHighVariantNeedUpdate) {
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      this.toggleAddButton(true, "");
      this.setUnavailable();
    } else {
      if (this.currentVariant?.featured_media) {
        this.updateMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`
        );
      }
      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
      });
      this.renderProductInfo(requestUrl);
    }
    const selectedValues = this.getSelectedValues();
    this.setCheckedInputsBySelectedValues(selectedValues);
  }
  isCombinedProductChange(productUrl) {
    if (!productUrl) return false;
    const currentProductUrl = this.dataset.url;
    if (!currentProductUrl) return true;
    return (
      this.normalizeProductUrl(productUrl) !==
      this.normalizeProductUrl(currentProductUrl)
    );
  }
  normalizeProductUrl(productUrl) {
    return new URL(productUrl, window.location.origin).pathname;
  }
  cleanErrors() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    if (!productForms || productForms.length === 0) return;
    productForms.forEach((productForm) => {
      const productFormWrapper = productForm.closest(".product-form");
      if (!productFormWrapper) return;
      const errorMessageWrapper = productFormWrapper.querySelector(
        ".product-form__error-message-wrapper"
      );
      if (!errorMessageWrapper) return;
      errorMessageWrapper.setAttribute("hidden", true);
    });
  }
  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".product-form__controls--dropdown")
    );
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
  }
  updateMasterId() {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }
  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }
  updateMedia(mediaId) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const currentSection = document.querySelector(
      `[data-section="main-${this.dataset.section}"]`
    );
    if (!currentSection) return;
    this.mediaList = currentSection.querySelector(".product-media__list");
    if (!this.mediaList) return;
    const activeMedia = this.mediaList.querySelector(
      `[data-media-id="${mediaId}"]`
    );
    this.mediaList.querySelectorAll("[data-media-id]").forEach((element) => {
      element.classList.remove("active");
    });
    if (activeMedia) activeMedia.classList.add("active");
    const swiperWrappers = currentSection.querySelectorAll(
      ".product-media__wrapper"
    );
    swiperWrappers.forEach((elem) => {
      if (!this.isHidden(elem)) {
        const mediaSlider = elem.querySelector(".js-media-list");
        const newMedia = elem.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        if (!mediaSlider?.swiper || !newMedia) return;
        const mediaIndex = mediaSlider.swiper.slides.indexOf(newMedia);
        if (mediaIndex >= 0) {
          mediaSlider.swiper.slideTo(mediaIndex);
        }
      }
    });
    this.syncPopupSliderToMedia(mediaId);
  }
  updateURL(
    productUrl = this.dataset.url,
    variantId = this.currentVariant?.id
  ) {
    if (!productUrl || this.dataset.updateUrl === "false") return;
    const nextUrl = variantId
      ? `${productUrl}?variant=${variantId}`
      : productUrl;
    window.history.replaceState({}, "", nextUrl);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        variant: this.currentVariant,
      },
    });
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled", "always-clickable");
          input.disabled = false;
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
          if (this.dataset.unavailableOptionsClickable === "true") {
            input.classList.add("always-clickable");
          } else {
            input.disabled = true;
          }
        }
      }
    });
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }
  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();
    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        try {
          this.setCurrentVariantAfterFetch(html);
          this.syncProductUrlFromHtml(html);
        } catch (err) {}
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updateURL();
            this.updatePickupAvailability();
            this.updatePickerInnerHtml(html);
            if (this.currentVariant) {
              this.updateVariantInput();
              if (this.currentVariant.featured_media) {
                const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
                this.updateMedia(mediaId);
              }
            }
          } catch (err) {}
        }
        this.updateElementsAfterFetch(html);
        if (this.currentVariant?.featured_media) {
          this.updateMedia(
            `${this.dataset.section}-${this.currentVariant.featured_media.id}`
          );
        }
        this.updateVariantSwatches(html);
        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      });
  }
  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;
    const addButtonText =
      productForm.querySelector('[name="add"] .button__label') ||
      addButton.querySelector("span");
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) {
        addButtonText.textContent = text;
        addButtonText.setAttribute("data-label", text);
      }
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window?.variantStrings?.addToCart;
      addButtonText.setAttribute(
        "data-label",
        window?.variantStrings?.addToCart
      );
    }
  }
  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    if (!addButton) return;
    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-all-variants-no-high]").textContent);
    return this.variantData;
  }
  getSelectedValues() {
    const controls = [...this.querySelectorAll(".product-form__controls")];
    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });
    const selectedValues = controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput ? checkedInput.value : null;
    });
    return selectedValues;
  }
  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];
    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });
    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput?.dataset?.optionValueId
        ? checkedInput.dataset.optionValueId
        : null;
    });
  }
  createRequestUrl({
    currentVariantId = "",
    selectedValuesIds = [],
    combinedProductURL = "",
  }) {
    const productUrl = combinedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }
    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
  }
  setCurrentVariantAfterFetch(html) {
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const variantPickerSource = html.getElementById(
      `variant-radios-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-radios-${this.dataset.section}`
    );
    if (!variantPickerSource || !variantPickerDestination) return;
    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;
    const newVariantData = variantPickerSource.querySelector(
      "[data-selected-variant]"
    ).innerHTML;
    const selectedVariant = !!newVariantData
      ? JSON.parse(newVariantData)
      : null;
    this.currentVariant = selectedVariant;
    const oldEl = variantPickerDestination.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.innerHTML = newVariantData;
    }
  }
  updateElementsAfterFetch(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const parentQuickView = this.closest("quick-add-modal");
    const parentFeaturedProduct = this.closest(".featured-product-section");
    const priceDestination = document.getElementById(
      `price-${currentSectionId}`
    );
    const priceSource = html.getElementById(`price-${sourceSectionId}`);
    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML;
      priceDestination.classList.remove("visibility-hidden");
    }
    const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
    const inventoryDestination = document.getElementById(
      `Inventory-${currentSectionId}`
    );
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.innerText === ""
      );
    }
    const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
    const skuDestination = document.getElementById(`Sku-${currentSectionId}`);
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    } else if (!skuSource && skuDestination) {
      skuDestination.classList.add("visibility-hidden");
    }
    const colorNameSources = html.querySelectorAll(
      `[id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = document.querySelectorAll(
      `[id^="ColorName-${currentSectionId}"]`
    );
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }
    this.syncGiftCardRecipientFormFromHtml(html);
    this.syncB2bQuantityPricingFromHtml(html, sourceSectionId, currentSectionId);
    if (parentQuickView) {
      const titleSource = html.querySelector(".product-title-wrapper");
      const titleDestination = document.querySelector(
        `#ProductInfo-${currentSectionId} .product-title-wrapper`
      );
      if (titleSource && titleDestination) {
        titleDestination.innerHTML = titleSource.innerHTML;
      }
      const descriptionSource = html.querySelector(
        ".product-description-wrapper"
      );
      const descriptionDestination = document.querySelector(
        `#ProductInfo-${currentSectionId} .product-description-wrapper`
      );
      if (descriptionSource && descriptionDestination) {
        descriptionDestination.innerHTML = descriptionSource.innerHTML;
      }
    } else if (parentFeaturedProduct) {
      this.syncFeaturedProductInfoFromHtml(html);
    } else if (!parentFeaturedProduct) {
      this.syncMainProductInfoFromHtml(html);
    }
    if (this.isCombinedListingsNeedUpdate) {
      const mediaSource = parentFeaturedProduct
        ? html.querySelector(
            `[data-section="main-${sourceSectionId}"] .product-media__wrapper`
          )
        : html.querySelector(
            `[data-section="product-media-${sourceSectionId}"]`
          );
      const mediaDestination = parentFeaturedProduct
        ? document.querySelector(
            `[data-section="main-${currentSectionId}"] .product-media__wrapper`
          )
        : document.querySelector(
            `[data-section="product-media-${currentSectionId}"]`
          );
      if (mediaSource && mediaDestination) {
        if (parentFeaturedProduct) {
          this.destroyFeaturedMediaSliders(currentSectionId);
        }
        mediaDestination.innerHTML = mediaSource.innerHTML;
        this.syncProductModalFromHtml(html);
        if (parentQuickView) {
          if (typeof parentQuickView.removeDOMElements === "function") {
            parentQuickView.removeDOMElements(mediaDestination);
          }
          if (typeof parentQuickView.initSlider === "function") {
            const modalContent = parentQuickView.querySelector(
              '[id^="QuickAddInfo-"]'
            );
            parentQuickView.initSlider(modalContent, true);
          }
        } else {
          this.ensureMediaSlidersInitialized();
          if (parentFeaturedProduct) {
            const section = document.getElementById(
              `shopify-section-${currentSectionId}`
            );
            if (section && typeof window.initFeaturedProduct === "function") {
              window.initFeaturedProduct(section);
            }
          } else {
            const section = document.getElementById(
              `shopify-section-${currentSectionId}`
            );
            if (section && typeof initProductPage === "function") {
              initProductPage(section);
            }
          }
        }
      }
    }
  }
  syncB2bQuantityPricingFromHtml(html, sourceSectionId, currentSectionId) {
    const productButtonsSource = html.querySelector(
      `[data-id="ProductButtons-${sourceSectionId}"]`
    );
    const productButtonsDestination = document.querySelector(
      `[data-id="ProductButtons-${currentSectionId}"]`
    );
    if (!productButtonsSource || !productButtonsDestination) return;
    const sourceButtonsWrapper = productButtonsSource.querySelector(
      ".product-form__buttons"
    );
    const destButtonsWrapper = productButtonsDestination.querySelector(
      ".product-form__buttons"
    );
    if (!sourceButtonsWrapper || !destButtonsWrapper) return;
    const sourceQuantityWrapper = sourceButtonsWrapper.querySelector(
      ".product-form__quantity"
    );
    const destQuantityWrapper = destButtonsWrapper.querySelector(
      ".product-form__quantity"
    );
    if (sourceQuantityWrapper && destQuantityWrapper) {
      destQuantityWrapper.innerHTML = sourceQuantityWrapper.innerHTML.replaceAll(
        sourceSectionId,
        currentSectionId
      );
    }
    const sourceHasQuantityPricing =
      sourceButtonsWrapper.dataset.hasQuantityPricing === "true";
    const destHadQuantityPricing =
      destButtonsWrapper.dataset.hasQuantityPricing === "true";
    if (!sourceHasQuantityPricing && !destHadQuantityPricing) return;
    if (sourceHasQuantityPricing) {
      destButtonsWrapper.dataset.hasQuantityPricing = "true";
    } else {
      delete destButtonsWrapper.dataset.hasQuantityPricing;
    }
    const sourceB2bEl = sourceButtonsWrapper.querySelector(
      ".product-b2b-elements"
    );
    const destB2bEl = destButtonsWrapper.querySelector(".product-b2b-elements");
    if (sourceB2bEl && destB2bEl) {
      destB2bEl.innerHTML = sourceB2bEl.innerHTML;
    } else if (sourceB2bEl && !destB2bEl) {
      destButtonsWrapper.insertAdjacentHTML("afterbegin", sourceB2bEl.outerHTML);
    } else if (!sourceB2bEl && destB2bEl) {
      destB2bEl.remove();
    }
  }
  syncGiftCardRecipientFormFromHtml(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const sourceInfo = html.getElementById(`ProductInfo-${sourceSectionId}`);
    const destinationInfo = document.getElementById(
      `ProductInfo-${currentSectionId}`
    );
    if (!sourceInfo || !destinationInfo) return;
    const sourceProductForm = sourceInfo.querySelector(
      "product-form.product-form"
    );
    const destinationProductForm = destinationInfo.querySelector(
      "product-form.product-form"
    );
    if (!sourceProductForm || !destinationProductForm) return;
    const sourceHideErrors = sourceProductForm.getAttribute("data-hide-errors");
    if (sourceHideErrors !== null) {
      destinationProductForm.setAttribute("data-hide-errors", sourceHideErrors);
    } else {
      destinationProductForm.removeAttribute("data-hide-errors");
    }
    const sourceRecipientForm =
      sourceProductForm.querySelector("recipient-form");
    const destinationRecipientForm =
      destinationProductForm.querySelector("recipient-form");
    if (sourceRecipientForm) {
      this.ensureRecipientFormScriptLoaded(sourceInfo);
      if (destinationRecipientForm) {
        destinationRecipientForm.outerHTML = sourceRecipientForm.outerHTML;
      } else {
        const destinationButtons = destinationProductForm.querySelector(
          ".product-form__buttons"
        );
        if (destinationButtons) {
          destinationButtons.insertAdjacentHTML(
            "beforebegin",
            sourceRecipientForm.outerHTML
          );
        }
      }
    } else if (destinationRecipientForm) {
      const recipientScript = destinationProductForm.querySelector(
        'script[src*="recipient-form.js"]'
      );
      destinationRecipientForm.remove();
      recipientScript?.remove();
    }
  }
  ensureRecipientFormScriptLoaded(sourceInfo) {
    if (customElements.get("recipient-form")) return;
    const sourceScript = sourceInfo.querySelector(
      'script[src*="recipient-form.js"]'
    );
    const scriptSrc = sourceScript?.getAttribute("src");
    if (!scriptSrc) return;
    if (document.querySelector(`script[src="${scriptSrc}"]`)) return;
    const scriptTag = document.createElement("script");
    scriptTag.src = scriptSrc;
    scriptTag.defer = true;
    document.head.appendChild(scriptTag);
  }
  destroyFeaturedMediaSliders(sectionId) {
    const featuredMediaRoot = document.querySelector(
      `[data-section="main-${sectionId}"]`
    );
    if (!featuredMediaRoot) return;
    featuredMediaRoot.querySelectorAll(".js-media-list").forEach((element) => {
      element.swiper?.destroy(true, true);
    });
    featuredMediaRoot
      .querySelectorAll(".js-media-sublist")
      .forEach((element) => {
        element.swiper?.destroy(true, true);
      });
  }
  syncFeaturedProductInfoFromHtml(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const sourceInfo = html.getElementById(`ProductInfo-${sourceSectionId}`);
    const destinationInfo = document.getElementById(
      `ProductInfo-${currentSectionId}`
    );
    if (!sourceInfo || !destinationInfo) return;
    const selectors = [
      ".product-title-wrapper",
      ".product-description-wrapper",
      ".product-text",
      ".product-tags",
      ".installment-wrapper",
    ];
    selectors.forEach((selector) => {
      const sourceElement = sourceInfo.querySelector(selector);
      const destinationElement = destinationInfo.querySelector(selector);
      if (sourceElement && destinationElement) {
        destinationElement.innerHTML = sourceElement.innerHTML;
      }
    });
  }
  syncMainProductInfoFromHtml(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const sourceInfo = html.getElementById(`ProductInfo-${sourceSectionId}`);
    const destinationInfo = document.getElementById(
      `ProductInfo-${currentSectionId}`
    );
    if (!sourceInfo || !destinationInfo) return;
    const selectors = [
      ".product-title-wrapper",
      ".product-description-wrapper",
      ".product-text",
      ".product-tags",
      ".installment-wrapper",
    ];
    selectors.forEach((selector) => {
      const sourceElement = sourceInfo.querySelector(selector);
      const destinationElement = destinationInfo.querySelector(selector);
      if (sourceElement && destinationElement) {
        destinationElement.innerHTML = sourceElement.innerHTML;
      }
    });
    const sourceMainTitle = sourceInfo.querySelector(
      "[data-main-product-title]"
    );
    const destinationMainTitle = destinationInfo.querySelector(
      "[data-main-product-title]"
    );
    if (sourceMainTitle && destinationMainTitle) {
      const mainProductTitle =
        sourceMainTitle.getAttribute("data-main-product-title") || "";
      destinationMainTitle.setAttribute(
        "data-main-product-title",
        mainProductTitle
      );
    }
  }
  ensureMediaSlidersInitialized() {
    const section = document.getElementById(
      `shopify-section-${this.dataset.section}`
    );
    if (!section) return;
    if (typeof subSliderInit === "function") {
      subSliderInit(section);
    }
    if (typeof sliderInit === "function") {
      sliderInit(section);
    }
  }
  syncProductModalFromHtml(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const modalDestination = document.getElementById(
      `ProductModal-${currentSectionId}`
    );
    const modalSource = html.getElementById(`ProductModal-${sourceSectionId}`);
    if (!modalDestination || !modalSource) return;
    const modalContentDestination = modalDestination.querySelector(
      ".product-media-modal__content"
    );
    const modalContentSource = modalSource.querySelector(
      ".product-media-modal__content"
    );
    if (!modalContentDestination || !modalContentSource) return;
    const wrapperDestination =
      modalContentDestination.querySelector(".swiper-wrapper");
    const wrapperSource = modalContentSource.querySelector(".swiper-wrapper");
    if (!wrapperDestination || !wrapperSource) return;
    wrapperDestination.innerHTML = wrapperSource.innerHTML;
    const popupSlider = modalContentDestination.swiper;
    if (popupSlider) {
      popupSlider.update();
      popupSlider.pagination?.render();
      popupSlider.pagination?.update();
      popupSlider.slideTo(0, 0);
    }
  }
  syncPopupSliderToMedia(mediaId) {
    const productModal = document.getElementById(
      `ProductModal-${this.dataset.section}`
    );
    const popupSlider = productModal?.querySelector(
      ".product-media-modal__content"
    )?.swiper;
    if (!productModal || !popupSlider) return;
    const slides = [
      ...productModal.querySelectorAll(".product-media-modal__item"),
    ];
    const rawMediaId = String(mediaId).replace(`${this.dataset.section}-`, "");
    const targetIndex = slides.findIndex((slide) => {
      if (slide.dataset.mediaModalId === mediaId) return true;
      return !!slide.querySelector(`[data-media-id="${rawMediaId}"]`);
    });
    if (targetIndex >= 0) {
      popupSlider.slideTo(targetIndex, 0);
      popupSlider.update();
    }
  }
  updatePickerInnerHtml(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const quickAddModal = this.closest("quick-add-modal");
    const variantPickerSource = html.getElementById(
      `variant-radios-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-radios-${currentSectionId}`
    );
    if (variantPickerSource && variantPickerDestination) {
      if (quickAddModal) {
        variantPickerDestination.innerHTML =
          variantPickerSource.innerHTML.replaceAll(
            sourceSectionId,
            `quickadd-${sourceSectionId}`
          );
      } else {
        variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
      }
      this.variantData = undefined;
    }
  }
  syncProductUrlFromHtml(html) {
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const sourceVariantPicker = html.getElementById(
      `variant-radios-${sourceSectionId}`
    );
    const nextProductUrl = sourceVariantPicker?.dataset?.url;
    if (nextProductUrl) {
      this.dataset.url = nextProductUrl;
    }
  }
  updateVariantSwatches(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const quickAddModal = this.closest("quick-add-modal");
    const variantSwatchesSource = html.querySelector(
      `#variant-radios-${sourceSectionId} [data-is-variant-image-swatch]`
    );
    const variantSwatchesDestination = document.querySelector(
      `#variant-radios-${currentSectionId} [data-is-variant-image-swatch]`
    );
    if (variantSwatchesSource && variantSwatchesDestination) {
      if (quickAddModal) {
        variantSwatchesDestination.innerHTML =
          variantSwatchesSource.innerHTML.replaceAll(
            sourceSectionId,
            `quickadd-${sourceSectionId}`
          );
      } else {
        variantSwatchesDestination.innerHTML = variantSwatchesSource.innerHTML;
      }
    }
  }
  setCheckedInputsBySelectedValues(selectedValues) {
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((groupEl, index) => {
      const selectedValue = selectedValues[index];
      if (!selectedValue) return;
      const inputs = [...groupEl.querySelectorAll('input[type="radio"]')];
      inputs.forEach((input) => {
        const shouldBeChecked = input.value === selectedValue;
        input.checked = shouldBeChecked;
        if (shouldBeChecked) {
          input.setAttribute("checked", "");
        } else {
          input.removeAttribute("checked");
        }
      });
    });
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled", "always-clickable");
        input.disabled = false;
      } else {
        input.classList.add("disabled");
        if (this.dataset.unavailableOptionsClickable === "true") {
          input.classList.add("always-clickable");
        } else {
          input.disabled = true;
        }
      }
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("variant-radios", VariantRadios);
class PasswordViewer {
  constructor() {
    const passwordField = document.querySelectorAll(".field--pass");
    passwordField.forEach((el) => {
      const input = el.querySelector("input");
      const btnWrapper = el.querySelector(".button-pass-visibility");
      const btnOpen = el.querySelector(".icon-eye-close");
      const btnClose = el.querySelector(".icon-eye");
      btnOpen.setAttribute("tabindex", 0);
      btnClose.setAttribute("tabindex", 0);
      input.addEventListener("input", () => {
        input.value !== ""
          ? (btnWrapper.style.display = "block")
          : (btnWrapper.style.display = "none");
      });
      btnOpen.addEventListener("click", () => {
        input.type = "text";
        btnOpen.style.display = "none";
        btnClose.style.display = "block";
      });
      btnOpen.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          input.type = "text";
          btnOpen.style.display = "none";
          btnClose.style.display = "block";
          btnClose.focus();
        }
      });
      btnClose.addEventListener("click", () => {
        input.type = "password";
        btnOpen.style.display = "block";
        btnClose.style.display = "none";
      });
      btnClose.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          input.type = "password";
          btnOpen.style.display = "block";
          btnClose.style.display = "none";
          btnOpen.focus();
        }
      });
    });
  }
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest(".product-recommendations-section");
    this.enableAnimation = this.dataset.enableHeaderAnimation === "true";
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.querySelector(".product-recommendations__loading")) {
        this.querySelector(".product-recommendations__loading").classList.add(
          "loading"
        );
        this.querySelector(".product-recommendations__loading").style.display =
          "flex";
      }
      if (this.enableAnimation) {
        this.section.classList.add("anim-active");
      }
      this.recommendationsSlider = null;
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          const updateNavPosition = () => {
            const section = this.closest(".product-recommendations-section");
            if (!section) return;
            const nav = section.querySelector(".product-recommendations-nav");
            if (!nav) return;
            const firstSlide = section.querySelector(
              ".product-recommendations-item"
            );
            if (!firstSlide) return;
            const imgWrapper = firstSlide.querySelector(".card");
            if (!imgWrapper) return;
            const swiperEl = section.querySelector(
              ".product-recommendations-layout"
            );
            const swiperRect = swiperEl.getBoundingClientRect();
            const imgRect = imgWrapper.getBoundingClientRect();
            const offsetTop = imgRect.top - swiperRect.top;
            const centerY = offsetTop + imgRect.height / 2;
            nav.style.top = `${centerY}px`;
          };
          const initSlider = () => {
            const section = this.closest(".product-recommendations-section");
            if (!section) return;
            const swiperEl = this.querySelector(
              ".product-recommendations-layout"
            );
            const swiperWrapper = this.querySelector(
              ".product-recommendations-list"
            );
            const slides = this.querySelectorAll(
              ".product-recommendations-item"
            );
            if (!swiperEl || !swiperWrapper || !slides || !slides.length)
              return;
            swiperEl.classList.add("swiper");
            swiperWrapper.classList.add("swiper-wrapper");
            slides.forEach((slide) => slide.classList.add("swiper-slide"));
            const prevBtn = section.querySelector(
              ".product-recommendations-nav-button--prev"
            );
            const nextBtn = section.querySelector(
              ".product-recommendations-nav-button--next"
            );
            const columns = Number(swiperEl.dataset.columns) || 3;
            const isCenteredSlides = Boolean(swiperEl.dataset.centeredSlides);
            const breakpointsConfig = {
              2: {
                576: { slidesPerView: 2.1, spaceBetween: 20 },
                990: { slidesPerView: 2.1, spaceBetween: 24 },
              },
              3: {
                576: { slidesPerView: 2.1, spaceBetween: 20 },
                990: { slidesPerView: 3.15, spaceBetween: 24 },
              },
              4: {
                576: { slidesPerView: 2.1, spaceBetween: 20 },
                990: { slidesPerView: 3.15, spaceBetween: 24 },
                1360: { slidesPerView: 4.15, spaceBetween: 24 },
              },
            };
            const centeredSlidesBreakpointsConfig = {
              576: { slidesPerView: 1.5, spaceBetween: 20 },
              990: { slidesPerView: 3.15, spaceBetween: 24 },
            };
            const sliderOptions = {
              slidesPerView: 1.15,
              spaceBetween: 16,
              speed: 800,
              allowTouchMove: true,
              centeredSlides: isCenteredSlides,
              centeredSlidesBounds: isCenteredSlides,
              breakpoints: isCenteredSlides
                ? centeredSlidesBreakpointsConfig
                : breakpointsConfig[columns],
              mousewheel: {
                forceToAxis: true,
              },
              a11y: {
                scrollOnFocus: false,
              },
              preventClicks: true,
              navigation:
                nextBtn && prevBtn
                  ? {
                      nextEl: nextBtn,
                      prevEl: prevBtn,
                      disabledClass: "swiper-button-disabled",
                    }
                  : false,
            };
            this.recommendationsSlider = new Swiper(swiperEl, sliderOptions);
            updateNavPosition();
            const nav = section.querySelector(".product-recommendations-nav");
            if (nav) {
              nav.classList.add("product-recommendations-nav--visible");
            }
          };
          const destroySlider = () => {
            if (!this.recommendationsSlider) return;
            const swiperEl = this.querySelector(
              ".product-recommendations-layout"
            );
            const swiperWrapper = this.querySelector(
              ".product-recommendations-list"
            );
            const slides = this.querySelectorAll(
              ".product-recommendations-item"
            );
            if (!swiperEl || !swiperWrapper || !slides || !slides.length)
              return;
            this.recommendationsSlider.destroy(true, true);
            this.recommendationsSlider = null;
            swiperEl.classList.remove("swiper");
            swiperWrapper.classList.remove("swiper-wrapper");
            slides.forEach((slide) => slide.classList.remove("swiper-slide"));
          };
          const initSection = () => {
            const section = this.closest(".product-recommendations-section");
            if (!section) return;
            const desktopLayout = this.dataset.layout;
            const mobileLayout = this.dataset.layoutMobile;
            let currentLayout = null;
            const sectionResizeObserver = new ResizeObserver((entries) => {
              const [entry] = entries;
              let newLayout;
              if (entry.contentRect.width < 576) {
                newLayout = mobileLayout;
              } else {
                newLayout = desktopLayout;
              }
              if (newLayout !== currentLayout) {
                if (this.recommendationsSlider) {
                  destroySlider();
                }
                if (newLayout === "slider") {
                  initSlider();
                }
                currentLayout = newLayout;
              }
              if (currentLayout === "slider") {
                updateNavPosition();
              }
            });
            sectionResizeObserver.observe(section);
          };
          initSection();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.querySelector(".product-recommendations__loading")) {
            this.querySelector(
              ".product-recommendations__loading"
            ).classList.remove("loading");
            this.querySelector(".product-recommendations__loading").remove();
          }
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector(".disclosure__list-wrapper"),
    };
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.elements.button.addEventListener("click", this.togglePanel.bind(this));
    this.addEventListener("keydown", this.onEscapePress.bind(this));
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }
  connectedCallback() {
    document.addEventListener("click", this.handleDocumentClick);
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }
  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }
  showPanel() {
    this.elements.button.setAttribute("aria-expanded", "true");
    this.elements.panel.removeAttribute("hidden");
    if (this.hasAttribute("data-header")) {
      this.positionPanel();
    }
  }
  positionPanel() {
    const panel = this.elements.panel;
    const panelRect = panel.getBoundingClientRect();
    const containerRight =
      this.closest(".burger-menu__top")?.getBoundingClientRect().right ||
      document.documentElement.clientWidth;
    if (containerRight - panelRect.right < 16) {
      panel.style.left = "auto";
      panel.style.right = "0";
    }
  }
  togglePanel() {
    if (this.elements.button.getAttribute("aria-expanded") === "true") {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }
  onEscapePress(event) {
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }
  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
    this.hidePanel();
  }
}
if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}
function slideUp(toggleEl, contentEl, duration = 300) {
  const height = contentEl.clientHeight;
  contentEl.style.transitionProperty = "height, margin, padding";
  contentEl.style.transitionDuration = duration + "ms";
  contentEl.style.overflow = "hidden";
  contentEl.style.height = height + "px";
  contentEl.style.padding = "0";
  contentEl.style.margin = "0";
  setTimeout(function () {
    contentEl.style.height = "0";
    contentEl.style.padding = "0";
    contentEl.style.margin = "0";
  }, 10);
  setTimeout(function () {
    toggleEl.classList.remove("active");
    contentEl.classList.remove("active");
    contentEl.style.removeProperty("height");
    contentEl.style.removeProperty("padding");
    contentEl.style.removeProperty("margin");
    contentEl.style.removeProperty("overflow");
    contentEl.style.removeProperty("transition-duration");
    contentEl.style.removeProperty("transition-property");
  }, duration);
}
function slideDown(toggleEl, contentEl, duration = 300) {
  toggleEl.classList.add("active");
  contentEl.classList.add("active");
  contentEl.style.overflow = "hidden";
  contentEl.style.height = "0";
  const height = contentEl.scrollHeight;
  setTimeout(function () {
    contentEl.style.height = height + "px";
  }, 10);
  setTimeout(function () {
    contentEl.style.removeProperty("overflow");
    contentEl.style.removeProperty("height");
  }, duration);
}
class ProductAdditionalService extends HTMLElement {
  static selectedServices = [];
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.variantId = this.dataset.serviceProductVariantId;
    this.mainProductTitle = this.dataset.mainProductTitle;
    this.productInfo = this.closest(`#ProductInfo-${this.sectionId}`);
    this.dynamicBtns = this.productInfo?.querySelector(
      ".product-form__checkout"
    );
    this.checkbox = this.querySelector("input[type='checkbox']");
    this.checkbox?.addEventListener("change", this.onSelect.bind(this));
  }
  onSelect(event) {
    event.preventDefault();
    const propertyName =
      window.cartStrings?.additional_service_property || "Added with";
    if (this.checkbox.checked) {
      if (
        !ProductAdditionalService.selectedServices.some(
          (item) => item.id === this.variantId
        )
      ) {
        ProductAdditionalService.selectedServices.push({
          id: this.variantId,
          quantity: 1,
          properties: {
            [`${propertyName}`]: this.mainProductTitle,
          },
        });
      }
    } else {
      ProductAdditionalService.selectedServices =
        ProductAdditionalService.selectedServices.filter(
          (item) => item.id !== this.variantId
        );
    }
    if (this.dynamicBtns) {
      this.dynamicBtns.classList.toggle(
        "disabled",
        ProductAdditionalService.selectedServices.length > 0
      );
    }
  }
  getItems(formData) {
    if (!formData || ProductAdditionalService.selectedServices.length === 0) {
      return;
    }
    const mainItemId = formData.get("id");
    const mainItemQuantity = formData.get("quantity");
    if (!mainItemId || !mainItemQuantity) return;
    const additionalItems = ProductAdditionalService.selectedServices.map(
      (service) => {
        return {
          id: service.id,
          quantity: service.quantity,
          properties: service.properties,
        };
      }
    );
    const mainProperties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith("properties[")) {
        const cleanKey = key.replace(/^properties\[(.*?)\]$/, "$1");
        mainProperties[cleanKey] = value;
      }
    }
    return [
      ...additionalItems,
      {
        id: mainItemId,
        quantity: mainItemQuantity,
        properties: mainProperties,
      },
    ];
  }
  clearItems() {
    ProductAdditionalService.selectedServices = [];
  }
}
if (!customElements.get("product-additional-service")) {
  customElements.define("product-additional-service", ProductAdditionalService);
}
